import React from 'react';


const LanguageToggle = ({ currentLanguage, onLanguageChange }) => {
  const languages = [
    { code: 'FR', label: 'Français', flag: '🇫🇷' },
    { code: 'EN', label: 'English', flag: '🇬🇧' },
    { code: 'ES', label: 'Español', flag: '🇪🇸' },
    { code: 'PL', label: 'Polski', flag: '🇵🇱' }
  ];

  return (
    <div className="flex items-center justify-center gap-2 mb-8">
      {languages?.map((lang) => (
        <button
          key={lang?.code}
          onClick={() => onLanguageChange(lang?.code)}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 ${
            currentLanguage === lang?.code
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
          aria-label={`Switch to ${lang?.label}`}
        >
          <span className="text-lg">{lang?.flag}</span>
          <span className="text-sm font-medium">{lang?.code}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageToggle;